import { useState } from "react";
import Navbar from "../../Navbar/NavbarComponent/Navbar";
import { LABELS } from "../../../shared/constants";
import { RatingQuestions, CommentFields } from "./Config";

// Feedback Form Configuration page — a thin tabbed wrapper over the two
// admin panels (Rating Questions / Comment Fields).
const FeedbackConfig = () => {
  const [activeTab, setActiveTab] = useState("questions");

  return (
    <div className="full-height">
      <Navbar title={LABELS.FEEDBACK_FORM_CONFIG_TEXT} />
      <main className="main-content">
        <div className="pt-3">
          <div className="container-fluid">
            <ul className="nav nav-tabs mb-3 gap-2 border-bottom-0">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "questions" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("questions")}
                  type="button"
                >
                  {LABELS.RATING_QUESTIONS_TEXT}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "fields" ? "active" : ""}`}
                  onClick={() => setActiveTab("fields")}
                  type="button"
                >
                  {LABELS.COMMENT_FIELDS_TEXT}
                </button>
              </li>
            </ul>

            <div className="card custom-card card-full">
              <div className="card-body">
                {activeTab === "questions" ? (
                  <RatingQuestions />
                ) : (
                  <CommentFields />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FeedbackConfig;
